<template>
    <div class="status-message" v-bind:class="[ open ? '' : 'close',color ]">
        <slot></slot>
        {{ message }}
        <a href="" v-if="timing > 0" class="close-message" @click.prevent="close">
            <span class="material-icons">cancel</span>
        </a>
    </div>
</template>

<script>
    module.exports = {
        created:function() {

        },
        data:function() {
            return {
                open:true,
                closeTimeout:false
            }
        },
        props: {
            message:{type:String},
            timing:{type:Number,default:2500},
            color:{type:String,default:'green-secondary'}
        },
        methods: {
            close:function() {
                this.open = false;
                clearTimeout(this.closeTimeout);
            }
        },
        mounted:function() {
            if(this.timing > 0) {
                this.closeTimeout = setTimeout(function () {
                    this.open = false;
                }.bind(this), this.timing);
            }
        }
    }
</script>
